import React, { useEffect, useState, useRef } from 'react'
import {
	Flexgrid,
	FlexgridItem,
	RadioButton,
	TextInput,
	Form,
} from '@wf-wfria/pioneer-core'

export function InvoiceSerialNumber({
	focusedElement,
	formatMessage,
	invoiceNumber,
	serialNumber,
	invoiceOrSerial,
	invoiceNumberInputClasses,
	serialNumberInputClasses,
	onChange,
	onFocusFactory,
	onBlur,
	onSelectInvoiceOrSerial,
	onTextInputValidator,
}) {
	const formRef = useRef()
	const [key, setKey] = useState(Date.now())
	useEffect(() => {
		// this is only good for CC
		if (
			focusedElement !== 'invoiceNumber' &&
			focusedElement !== 'serialNumber' &&
			focusedElement !== 'userEmail' &&
			focusedElement !== 'existingUserEmail' &&
			focusedElement !== 'customerNumber' &&
			focusedElement !== 'contractNumber'
		) {
			if (formRef.current.validateField) {
				formRef.current.resetField('invoiceNumber')
			}

			if (formRef.current.validateField) {
				formRef.current.resetField('serialNumber')
			}
			const newKey = Date.now()
			setKey(newKey)
		}
	}, [focusedElement, setKey])

	const invoiceValue = invoiceNumber.value
	const serialValue = serialNumber.value
	const invoiceOrSerialInputDisabled = !invoiceOrSerial

	const isSelectedSerial = invoiceOrSerial === 'serial'
	const isSelectedInvoice = invoiceOrSerial === 'invoice'

	function getInvoiceOrSerial(invoiceOrSerial) {
		if (invoiceOrSerial === 'invoice') {
			return 'invoiceNumber'
		}
		return 'serialNumber'
	}

	function getInvoiceOrSerialInputClasses(invoiceOrSerial) {
		if (invoiceOrSerial === 'invoice') {
			return invoiceNumberInputClasses
		}
		return serialNumberInputClasses
	}

	function invokeOnSelectInvoiceOrSerial({ value }) {
		onSelectInvoiceOrSerial(value)
	}

	const isArialLabelSelected = isSelectedInvoice
		? `${formatMessage({
				id: 'wca-form.new-user-registration.invoice-number.label',
			})}`
		: `${formatMessage({
				id: 'wca-form.new-user-registration.serial-number.label',
			})}`

	let labelToDisplay = ''
	if (!invoiceOrSerialInputDisabled) {
		labelToDisplay = isSelectedInvoice
			? `${formatMessage({
					id: 'wca-form.new-user-registration.invoice-number.label',
				})}`
			: `${formatMessage({
					id: 'wca-form.new-user-registration.serial-number.label',
				})}`
	}

	return (
		<Form action="#" ref={formRef}>
			<Flexgrid
				direction="row"
				alignVertical="center"
				columnGap={2}
				style={{ marginTop: '18px' }}
			>
				<FlexgridItem span={12}>
					<label htmlFor={getInvoiceOrSerial(invoiceOrSerial)}>
						{formatMessage({
							id: 'wca-form.new-user-registration.invoice-and-serial-number.label',
						})}
					</label>
				</FlexgridItem>
				<FlexgridItem span={{ xxs: 4, sm: 4 }} style={{ marginTop: '16px' }}>
					<RadioButton
						label={formatMessage({
							id: 'wca-form.new-user-registration.invoice.label',
						})}
						role="radio"
						value={'invoice'}
						name="invoice"
						onValueChange={invokeOnSelectInvoiceOrSerial}
						checked={isSelectedInvoice}
					/>
					<RadioButton
						label={formatMessage({
							id: 'wca-form.new-user-registration.serial.label',
						})}
						role="radio"
						value={'serial'}
						name="serial"
						onValueChange={invokeOnSelectInvoiceOrSerial}
						checked={isSelectedSerial}
					/>
				</FlexgridItem>
				{invoiceOrSerial !== 'serial' && (
					<FlexgridItem span={{ xxs: 8, sm: 8 }}>
						<TextInput
							key={key}
							aria-label={isArialLabelSelected}
							label={labelToDisplay}
							labelHidden={true}
							required={true}
							aria-required={true}
							disabled={invoiceOrSerialInputDisabled}
							id={'invoiceNumber'}
							name={'invoiceNumber'}
							type="text"
							size="25"
							value={invoiceValue}
							onValueChange={onChange}
							onFocus={onFocusFactory('WcaRegister')}
							onBlur={onBlur}
							customValidators={[
								(value) =>
									onTextInputValidator(getInvoiceOrSerial('invoice'), value),
							]}
							nativeValidationMessages={{
								valueMissing: formatMessage({
									id: 'required-field.empty.error.label',
								}),
							}}
						/>
					</FlexgridItem>
				)}
				{invoiceOrSerial === 'serial' && (
					<FlexgridItem span={{ xxs: 8, sm: 8 }}>
						<TextInput
							key={key}
							aria-label={isArialLabelSelected}
							label={labelToDisplay}
							labelHidden={true}
							aria-required={true}
							required={true}
							disabled={invoiceOrSerialInputDisabled}
							id={'serialNumber'}
							name={'serialNumber'}
							type="text"
							size="25"
							value={serialValue}
							onValueChange={onChange}
							onFocus={onFocusFactory('WcaRegister')}
							onBlur={onBlur}
							customValidators={[
								(value) =>
									onTextInputValidator(getInvoiceOrSerial('serial'), value),
							]}
							nativeValidationMessages={{
								valueMissing: formatMessage({
									id: 'required-field.empty.error.label',
								}),
							}}
						/>
					</FlexgridItem>
				)}
			</Flexgrid>
		</Form>
	)
}
